import React from "react";

interface UserNotExistsProps {
  permissionName?: string | null;
}

const UserNotExists: React.FC<UserNotExistsProps> = ({ permissionName }) => {
  let convertedOutput = null;
  if (permissionName) {
    convertedOutput = permissionName
      .split(",")
      .map((item: any) => `'${item.trim()}'`)
      .join(", ");
  }

  return (
    <div className="container container-wrapper p-4">
      <div className="alert text-center globalsetup">
        <h4>No Users Available for Jones</h4>
        <h5>
          To continue, please add at least one Procore user to the company permission templates mapped for this integration:
        </h5>
        <h5>
          {convertedOutput
            ? `${convertedOutput} or Admin permissions on the Directory / Commitments Tool are required.`
            : "Admin permissions on the Directory / Commitments Tool are required."}
        </h5>
        <br />
      </div>
    </div>
  );
};

export default UserNotExists;